import { create } from 'zustand';
import { shallow } from 'zustand/shallow';

export type OptionsState = {
  options: Record<string, string[]>;
  setOptions: (options: Record<string, string[]>) => void;
};

export const useOptionsStore = create<OptionsState>((set) => ({
  options: {},
  setOptions: (options) => set({ options: options }),
  shallow,
}));
